import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";
import {Nav, Navbar, NavbarText, NavItem, NavLink} from "reactstrap";
import TextLabel from "../../controls/TextLabel/TextLabel.mjs";
import AppUsersIcon from "../../media/app-images/AppUsersIcon.mjs";
import AppPerimeterIcon from "../../media/app-images/AppPerimeterIcon.mjs";
import AppUploadIcon from "../../media/app-images/AppUploadIcon.mjs";
import AppSynthDataIcon from "../../media/app-images/AppSynthDataIcon.mjs";
import AppGestionePerimetriIcon from "../../media/app-images/AppGestionePerimetriIcon.mjs";
import AppAdminIcon from "../../media/app-images/AppAdminIcon.mjs";
import AppCpeCveIcon from "../../media/app-images/AppCpeCveIcon.mjs";
import AppCpeCveExplorerIcon from "../../media/app-images/AppCpeCveExplorerIcon.mjs";
import "./SideBar.css";
import PropTypes from "prop-types";
import AppSimulationIcon from "../../media/app-images/AppSimulationIcon.mjs";
import ListIcon from "../../media/images/ListIcon.mjs";
import AppSynthGenIcon from "../../media/app-images/AppSynthGenIcon.mjs";
import AppLogIcon from "../../media/app-images/AppLogIcon.mjs";
import AppCreateNewIcon from "../../media/app-images/AppCreateNewIcon.mjs";
import AppEditIcon from "../../media/app-images/AppEditIcon.mjs";

const prefix="SideBar";

const SidebarSection = class extends Component {
	static propTypes = {
		label: PropTypes.node.isRequired,
		icon: PropTypes.node,
		hidden: PropTypes.bool,
		children: PropTypes.node,
	}
	render() {
		if ( this.props.hidden ) return null;
		return(
			<Navbar>
				<NavbarText>
					{ this.props.icon }
					{ this.props.label }
				</NavbarText>
				<Nav>
					{ this.props.children }
				</Nav>
			</Navbar>
		)
	}
}

const SideBarLink = class extends Component {
	static propTypes = {
		panel: PropTypes.string.isRequired,
		label: PropTypes.node.isRequired,
		icon: PropTypes.node,
		hidden: PropTypes.bool
	}
	constructor(props) {
		super(props);
		this.state = {
			active: this.props.active ?? (Glob.getCurrentPage().name === props.panel)
		};
		this.uid = Glob.generateUid('SideBarLink');
	}
	componentDidMount() {
		Glob.register('currentPage', cp => {
			this.setState({active: this.props.active ?? (cp.name === this.props.panel)});
		}, this.uid);
	}
	componentWillUnmount() {
		Glob.unregister('currentPage', this.uid);
	}
	render() {
		if ( this.props.hidden ) return null;
		return(
			<NavItem id={this.uid}>
				<NavLink
					active={ this.state.active }
					onClick={() => { Glob.gotoPage(this.props.panel);} }
				>
					{ this.props.icon }
					<span>{ this.props.label }</span>
				</NavLink>
			</NavItem>
		)
	}
}

const SideBar = class extends Component{
	constructor(props) {
		super(props);
		const ul = Glob.getStatus('userLogin');
		this.state = {
			changed: Date.now(),
			cp: Glob.getCurrentPage(),
			active: true,
			user: ul,
			admin: appLib.admin(),
			enabled: appLib.enabled()
		};
		this.uid = Glob.generateUid(prefix);
	}
	componentDidMount() {
		Glob.register('userLogin', ul => {
			this.setState({user: ul, admin: appLib.admin(), enabled: appLib.enabled() });
		}, this.uid);
		Glob.register('slider', s => {
			if ( s !== this.state.active ) this.setState({active: s });
		}, this.uid);
		Glob.register('currentPage', cp => {
			this.setState({ active: cp.name, cp: cp, changed: Date.now() });
		}, this.uid);
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	render() {
		if ( ! this.state.user ) return null;
		return (
			<div
				className={"slider-area "+prefix}
				id={this.uid}
				onDoubleClick={ event => {
					event.stopPropagation();
					if( event.target.getAttribute('id') === this.uid ) event.target.style.width = '';
				}}
			>
				<div className={"header"}>
					<span>{ process.env.REACT_APP_DESCRIPTION }</span>
				</div>
				<SidebarSection
					icon={<AppCpeCveIcon />}
					label={<TextLabel value={"CVE"} />}
				>
					<SideBarLink
						panel={"CveList"}
						icon={ <ListIcon /> }
						label={ <TextLabel value={"Available CVEs"} /> }
					/>
					<SideBarLink
						panel={"CveExplorer"}
						icon={ <AppCpeCveExplorerIcon /> }
						label={ <TextLabel value={"Cve Explorer"} /> }
					/>
					<SideBarLink
						panel={"CveLoader"}
						icon={ <AppUploadIcon /> }
						label={ <TextLabel value={"CveLoader"} /> }
					/>
				</SidebarSection>
				<SidebarSection
					icon={<AppPerimeterIcon />}
					label={<TextLabel value={"Perimeters"} />}
				>
					<SideBarLink
						panel={"Perimeters"}
						icon={ <AppGestionePerimetriIcon /> }
						label={ <TextLabel value={"Available perimeters"} /> }
					/>
					<SideBarLink
						hidden={! this.state.enabled }
						panel={"RealPeriUpload"}
						icon={ <AppUploadIcon /> }
						label={<TextLabel value={"Upload real data"}/>}
					/>
					<SideBarLink
						hidden={! this.state.enabled }
						panel={"SynthUpload"}
						icon={ <AppSynthDataIcon /> }
						label={<TextLabel value={"Upload synthetic data"}/> }
					/>
					<SideBarLink
						hidden={! this.state.enabled }
						panel={"SynthGen"}
						icon={ <AppSynthGenIcon /> }
						label={<TextLabel value={"Synthetic data generator"}/> }
					/>
				</SidebarSection>
				<SidebarSection
					label={<TextLabel value={"Simulations"}/>}
					icon={<AppSimulationIcon /> }
				>
					<SideBarLink
						panel={"Simulations"}
						icon={<ListIcon />}
						label={<TextLabel value={"Available simulations"} /> }
					/>
					<SideBarLink
						hidden={! this.state.enabled || this.state.active!=="SimulationFlowEdit" }
						panel={"SimulationFlowEdit"}
						icon={<AppEditIcon /> }
						label={<TextLabel value={"Edit Simulation"}/> }
					/>
					<SideBarLink
						hidden={! this.state.enabled }
						panel={"SimulationFlowNew"}
						icon={<AppCreateNewIcon /> }
						label={<TextLabel value={"New Simulation"}/> }
					/>
				</SidebarSection>
				<SidebarSection
					hidden={! this.state.admin }
					icon={<AppAdminIcon />}
					label={<TextLabel value={"Administration"} />}
				>
					<SideBarLink
						panel={"LogView"}
						icon={<AppLogIcon />}
						label={ <TextLabel value={"LogView"} /> }
					/>
					<SideBarLink
						panel={"UsersManagement"}
						icon={ <AppUsersIcon /> }
						label={ <TextLabel value={"UsersManagement"} /> }
					/>
				</SidebarSection>
			</div>
		)
	}
}

export default SideBar;
